export * from './theme';
export * from './firebaseConfig';

// og:tags section
export const TITLE = 'FS ČCE v Praze 9 - Horních Počernicích';
export const PREFIX = 'Farní sbor';
export const CHURCH = 'Českobratrské církve evangelické';
export const PLACE = 'v Praze 9 - Horních Počernicích';
export const HERO_SIZE = 450;
